<template>
  <div class="community-advanced-search">
    <div class="d-flex mb-3">
      <strong class="flex-fill">Pesquisar colaboradores</strong>
      <button @click="$emit('close')" class="btn text-light p-0">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- avoid autocomplete -->
    <form-group id="email" name="email" class="d-none" />

    <div class="row">
      <div class="col-lg-8">
        <form-group v-model="searchTerm" placeholder="Buscar" id="search" />
      </div>
      <div class="col-lg-4">
        <form-group
          placeholder="Temperamento"
          has-icon
          select
          nullable
          v-model="params.temper"
          :options="temperOptions"
          class="mb-1"
          id="temper"
        >
          <template v-slot:icon>
            <img :src="temperImage(params.temper)" />
          </template>
        </form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-lg">
        <form-group
          v-model="params.country"
          placeholder="País"
          select
          nullable
          :options="countryOptions"
          id="country"
        />
      </div>
      <div class="col-lg" v-if="params.country === 'BRA'">
        <form-group
          v-model="params.state"
          placeholder="Estado"
          select
          nullable
          :options="stateOptions"
          id="state"
        />
      </div>
      <div class="col-lg">
        <form-group v-model="cityTerm" placeholder="Cidade" id="city" />
      </div>
    </div>

    <action-dispatcher
      :key="key"
      action="community/getUsers"
      :parameters="{ limit: 20, ...params }"
    >
      <table>
        <tr
          class="cursor-pointer"
          v-for="user in users"
          :key="user.id"
          @click="$emit('user', user)"
        >
          <td>
            <img
              v-if="user.picture"
              :src="user.picture"
              class="rounded-circle img-fluid user-picture"
            />
            <img
              v-else
              src="@/assets/images/avatar.png"
              class="rounded-circle img-fluid user-picture"
            />
          </td>
          <td class="fw-500">{{ user.name }}</td>
          <td class="text-secondary">
            <i v-if="user.occupation" class="fas fa-briefcase mr-1"></i>
            {{ user.occupation }}
          </td>
          <td>
            <div class="d-flex align-items-center text-secondary">
              <img
                v-if="user.temper"
                :src="temperImage(user.temper)"
                class="mr-1"
              />
              {{ temperName(user.temper) }}
            </div>
          </td>
          <td v-if="user.localization" class="text-secondary">
            <i class="fas fa-map-marker-alt mr-1"></i>
            Mora em
            {{ user.localization.city }},
            {{ user.localization.state }}
          </td>
        </tr>
      </table>
    </action-dispatcher>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { countries, states } from "@/functions/helpers.js";

export default {
  data() {
    return {
      params: {
        search: "",
        temper: "",
        state: "",
        country: ""
      },
      temperOptions: [
        { id: "colerico", name: "Colérico" },
        { id: "melancolico", name: "Melancólico" },
        { id: "fleumatico", name: "Fleumático" },
        { id: "sanguineo", name: "Sanguíneo" }
      ],
      countryOptions: countries.map(c => ({ id: c[0], name: c[1] })),
      stateOptions: states.map(c => ({ id: c[0], name: c[1] })),
      searchTerm: "",
      cityTerm: "",
      timeout: null
    };
  },
  computed: {
    ...mapState("community", ["users"]),
    key() {
      return JSON.stringify(this.params);
    }
  },
  watch: {
    searchTerm() {
      this.liveSearch();
    },
    cityTerm() {
      this.liveSearch();
    }
  },
  methods: {
    liveSearch() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.params.search = this.searchTerm + " " + this.cityTerm;
      }, 500);
    },
    temperImage(temper) {
      return require(`../../assets/images/temperamentos/${temper ||
        "todos"}.svg`);
    },
    temperName(temper) {
      return this.temperOptions.find(t => t.id === temper)?.name;
    }
  }
};
</script>

<style lang="scss">
.community-advanced-search {
  table {
    width: 100%;

    td {
      vertical-align: middle;
      padding: 8px 4px;
    }

    .user-picture {
      max-width: 32px;
      max-height: 32px;
      min-width: 32px;
      min-height: 32px;
    }
  }
}
</style>
